// VTI rank naming + dial artwork, keyed off the same score thresholds the
// backend uses in go-carrera `VtiRatingService.getRank()`. Keep the two in sync:
// if the bands move server-side, they must move here too.
//
// This exists so the profile shows the VTI rank by NAME (Rookie ... Elite
// Artisan) rather than a bare dial or the legacy 0-5 hammer number.
export type VtiRank =
  | 'Rookie'
  | 'Intermediate'
  | 'Experienced'
  | 'Proficient'
  | 'Expert'
  | 'Master'
  | 'Artisan'
  | 'Elite Artisan';

const BANDS: { max: number; rank: VtiRank }[] = [
  { max: 0.25, rank: 'Rookie' },
  { max: 0.75, rank: 'Intermediate' },
  { max: 1.5, rank: 'Experienced' },
  { max: 2.5, rank: 'Proficient' },
  { max: 3.5, rank: 'Expert' },
  { max: 4.5, rank: 'Master' },
  { max: 5.25, rank: 'Artisan' },
];

export function vtiRankFromRating(rating?: number | null): VtiRank {
  const score = rating ?? 0;
  return BANDS.find(band => score < band.max)?.rank ?? 'Elite Artisan';
}

export function vtiDialImagePath(rating?: number | null): string {
  return `assets/images/VTI-imgs/VTI Dial-${vtiRankFromRating(rating)}.png`;
}
